

/***************************** HISTORY PAGE ***************/
window.addEventListener('DOMContentLoaded', function () {
    var elementsCollapse = [].slice.call(document.querySelectorAll('[data-collapse]'));
    var resendBtns = [].slice.call(document.querySelectorAll('.to-stop-propagation'));
    var historyTabsLinks = [].slice.call(document.querySelectorAll('.history-tabs-link'));
    var historyCards = [].slice.call(document.querySelectorAll('.history-card'));

    elementsCollapse.forEach(function (el) {
        el.addEventListener('click', function () {
            return el.classList.toggle('active');
        });
    });

    resendBtns.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
            return e.stopPropagation();
        });
    });

    historyTabsLinks.forEach(function (link) {
        link.addEventListener('click', function (e) {
            e.preventDefault();

            historyTabsLinks.forEach(function (el) {
                return el.classList.remove('active');
            });
            historyCards.forEach(function (card) {
                return card.classList.remove('active');
            });
            link.classList.add('active');

            var tabContentToOpen = document.querySelector(link.getAttribute('href'));
            tabContentToOpen.classList.add('active');
        });
    });
});


if (!String.prototype.toLocalCulture) {
    // toLocalCulture only works with strings. Make sure you pass on a string`
    String.prototype.toLocalCulture = function (digitsAfterComma) {
        digitsAfterComma = isNaN(digitsAfterComma) ? 2 : digitsAfterComma;
        return parseFloat(this.replace(',', '.')).toLocaleString(window.navigator.userLanguage || window.navigator.language || "en-US", // "de-AT"
            {
                minimumFractionDigits: digitsAfterComma,
                maximumFractionDigits: digitsAfterComma
            });
    };
}